import { operatorApiFetch } from './apiService';

export const operatorService = {
  // 獲取操作員列表
  getRecords: async (params) => {
    const response = await operatorApiFetch('operators/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 獲取所有操作員 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('operators/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 獲取當前操作員
  getCurrent: async () => {
    const response = await operatorApiFetch('current_operator', { method: 'GET' });
    return response.json();
  },

  // 獲取指定操作員
  get: async (id) => {
    const response = await operatorApiFetch(`operators/${id}`, { method: 'GET' });
    return response.json();
  },

  // 更新操作員關聯的貨主
  updateMerchants: async (id, merchantIds) => {
    const response = await operatorApiFetch(`operators/${id}/update_merchants`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        merchant_ids: merchantIds
      }),
    });
    return response.json();
  },

  // 停用操作員（踢出所有裝置）
  disable: async (id) => {
    const response = await operatorApiFetch(`operators/${id}/disable`, { method: 'POST' });
    return response.json();
  },

  // 重新啟用操作員
  enable: async (id) => {
    const response = await operatorApiFetch(`operators/${id}/enable`, { method: 'POST' });
    return response.json();
  },
};
export default operatorService;
